import {getAbsoluteUrl} from "../../utils/urlUtill";
import {
    GroupedOpportunityKey,
    OpportunityAction,
    OpportunityActionsGroup
} from "../../opportunity_actions/model/OpportunityAction";
import {Observable, Subject} from 'rxjs';
import {filter, flatMap} from 'rxjs/operators';
import {IHttpPromise} from "angular";
import {ActionTypes} from "../../action_status/model/ActionType";


export class ActionService {

    public static instance = ['$http', ActionService];
    private $http: ng.IHttpService;
    private groupedActionsSubject: Subject<OpportunityActionsGroup> = new Subject<OpportunityActionsGroup>();

    constructor($http: ng.IHttpService) {
        this.$http = $http;
    }

    getActionsObservable = (groupId: GroupedOpportunityKey): Observable<OpportunityAction> => this.groupedActionsSubject
        .pipe(
            filter(action => groupId.equals(action.key)),
            flatMap(action => action.value)
        );

    emitOpportunityActionsGroup = (groups: OpportunityActionsGroup) => {
        this.groupedActionsSubject.next(groups);
    };

    emitAllOpportunityActionsGroups = (groups: OpportunityActionsGroup[]) => {
        groups.forEach(this.emitOpportunityActionsGroup);
    };

    sendActionRequest = (opportunityId: number,
                         opportunityAction: OpportunityAction): IHttpPromise<OpportunityAction[]> => {
        return <IHttpPromise<OpportunityAction[]>>this.$http({
            url: getAbsoluteUrl(`api/opportunity/${opportunityId}/action`, {type: ActionTypes.EMAIL}),
            method: 'POST',
            data: opportunityAction
        });
    };

    sendSmsRequest = (opportunityId: number): IHttpPromise<OpportunityAction[]> => {
        return <IHttpPromise<OpportunityAction[]>>this.$http({
            url: getAbsoluteUrl(`api/sms-text/?executionLogId=${opportunityId}`),
            method: 'GET'
        });
    };


    findCustomerActions = (customerId: number): IHttpPromise<OpportunityAction[]> =>
        this.$http({
            url: getAbsoluteUrl('api/opportunity/actions'),
            method: 'GET',
            params: {
                'include_unsubscriptions': true,
                'customer_id': customerId
            }
        });

    findActions = (opportunityId: number): IHttpPromise<OpportunityAction[]> =>
        this.$http({
            url: getAbsoluteUrl(`api/opportunity/${opportunityId}/action`),
            method: 'GET'
        });

    cancelAction = (opportunityAction: OpportunityAction): IHttpPromise<OpportunityAction> =>
        this.$http({
            url: getAbsoluteUrl(`api/opportunity/actions`),
            method: 'PUT',
            data: opportunityAction
        });

    getOpportunityActions = (opportunityIds: number[]): IHttpPromise<OpportunityAction[]> =>
        this.$http({
            url: getAbsoluteUrl(`api/opportunity/actions`),
            data: {opportunityIds: opportunityIds},
            method: 'POST'
        })

}